//External Libraries
import { faXmark as farXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

//Components
import { CMButton } from '@chartmetric/chartmetric-design-system/components/CMButton';
import { CMFlex } from '@chartmetric/chartmetric-design-system/components/CMFlex';

interface CommentImageThumbnailProps {
  url: string;
  alt: string;
  onClick: () => void;
  onRemove?: () => void;
}

function CommentImageThumbnail({ url, alt, onClick, onRemove }: CommentImageThumbnailProps) {
  return (
    <CMFlex
      borderColor="lightGray"
      r="sm"
      overflow="hidden"
      position="relative"
      width="w-32"
      height="h-32"
      _className="shrink-0"
    >
      <button
        type="button"
        onClick={onClick}
        aria-label={alt}
        className="flex w-full h-full p-0 border-0 bg-transparent cursor-zoom-in"
      >
        <img src={url} alt={alt} className="w-full h-full object-cover" />
      </button>
      {onRemove && (
        <CMButton
          iconLeft={farXmark}
          variant="secondaryText"
          size="xs"
          shape="circle"
          onClick={onRemove}
          _className="absolute top-1 right-1"
        />
      )}
    </CMFlex>
  );
}

export default CommentImageThumbnail;
